import Icon from "../../components/Icon/icon";
import LinkButton, { LinkButtonType } from "../../components/LinkButton/LinkButton";

import { BrandLinks, returnLinkForTag, returnIcon, formatTag } from "./data";

interface Props {
  params: Partial<{ brand: string; slug: string }>;
  selectedTag: string | null;
}

const ProductFilter = (props: Props) => {
  const { params, selectedTag } = props;

  return (
    <>
      {params.brand && (
        <Icon name={returnIcon(params.brand)} iconWidth="18rem" className="brand-logo" />
      )}
      <div className="button-container">
        <div className="divider" />
        <div className="buttons-wrapper">
          {BrandLinks.filter((brand) => brand.brand === params.brand).flatMap((brand, brandIndex) =>
            brand.headers.map((header, headerIndex) => {
              const isActive = formatTag(selectedTag ?? "") === formatTag(header);

              return (
                <LinkButton
                  to={returnLinkForTag(header, isActive)}
                  key={`${brandIndex}-${headerIndex}`}
                  type={isActive ? undefined : LinkButtonType.secondary}
                  disabled={isActive}
                >
                  {header}
                </LinkButton>
              );
            }),
          )}
        </div>
      </div>
    </>
  );
};

export default ProductFilter;
